import { createClient } from '@supabase/supabase-js'

import { env, isSupabaseConfigured } from '@/lib/env'
import type { Database } from '@/types/supabase'

const fallbackUrl = 'https://example.supabase.co'
const fallbackPubKey = 'public-publishable-key'

export const supabase = createClient<Database>(
  env.supabaseUrl ?? fallbackUrl,
  env.supabasePubKey ?? fallbackPubKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  },
)

export { isSupabaseConfigured }
